<template>
  <qx-card-form title="借支信息">
    <span slot="titleLeft">
      <template v-if="$route.query.type === 'add'">
        <span class="applyInfoLabel">（申请人：</span>
        <span class="primary">{{ userInfo.staffTFInfo && userInfo.staffTFInfo.linkman }}</span>
        <span class="applyInfoLabel">申请时间：</span>
        <span class="primary">{{ applyTime }}</span>
        ）
      </template>
      <template v-if="$route.query.type === 'edit'">
        <span class="applyInfoLabel">（申请人：</span>
        <span class="primary">{{ applyInfo.borrowName }}</span>
        <span class="applyInfoLabel">申请时间：</span>
        <span class="primary">{{ applyInfo.applyTime }}</span>
        ）
      </template>
    </span>
    <qx-custom-form :noSubBtn="true" ref="baseForm" :formData="baseForm" labelWidth="120px">
      <section slot="order" slot-scope="prop">
        <ChooseOrder
          slot="order"
          :isRadio="true"
          v-model="prop.form.order"
          @change="handleOrderChange"
        />
      </section>
      <section slot="plateNumberInfo" slot-scope="prop">
        <ChooseCar :isRadio="true" v-model="prop.form.plateNumberInfo" />
      </section>
      <span slot="weightUnit" class="unit">kg</span>
    </qx-custom-form>
  </qx-card-form>
</template>

<script>
import {
  mapState,
} from 'vuex';
import ChooseOrder from 'components/choose/order';
import ChooseCar from 'components/choose/car';
export default {
  components: {
    ChooseOrder,
    ChooseCar,
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo, // 用户信息
    }),
  },
  data () {
    return {
      applyTime: this.formatDate(new Date(), 1),
      applyInfo: {},
      baseForm: {
        loanSubjectOptions: [], // 借支类型
        // isNeedBillOptions: [], // 借支票据
        form: [
          {
            label: '借支金额',
            value: 'amount',
            type: 'input',
          },
          {
            label: '订单号码',
            value: 'order',
            slot: true,
            default: {},
            hide: false,
          },
          {
            label: '借款用途',
            value: 'loanSubject',
            type: 'select',
            multiple: true,
            multipleLimit: 3,
            onChange: () => {
              this.handleTypeChange();
            },
          },

          {
            label: '过磅重量',
            value: 'weight',
            type: 'input',
            hide: true,
          },
          {
            label: '车牌号码',
            value: 'plateNumber',
            type: 'input',
            hide: false,
          },
          {
            label: '车牌号码',
            value: 'plateNumberInfo',
            type: 'input',
            hide: true,
            slot: true,
          },
          {
            label: '司机姓名',
            value: 'carOwnerName',
            type: 'input',
            disabled: true,
            hide: false,
          },
          {
            label: '司机手机',
            value: 'carPhone',
            type: 'input',
            disabled: true,
            hide: false,
          },
          // {
          //   label: '借支票据',
          //   value: 'isNeedBill',
          //   type: 'select',
          // },
          {
            label: '借款说明',
            value: 'appReason',
            type: 'input',
            attr: {
              type: 'textarea',
            },
          },
          {
            label: '上传附件',
            value: 'file',
            type: 'img',
            accept: 'image/*',
            fileSize: 5120,
            default: [],
          },
        ],
        rules: {
          loanSubject: [ // 借款用途
            { required: true, message: '请选择借款用途', trigger: 'blur' },
          ],
          amount: [ // 借支金额
            { required: true, message: '请输入借支金额', trigger: 'blur' },
          ],
          plateNumberInfo: [ // 车牌号码
            { required: true, message: '请选择车牌号码', trigger: 'blur' },
          ],
          order: [ // 订单号码
            { required: true, message: '请选择订单', trigger: 'blur' },
          ],
          appReason: [ // 借款说明
            { required: true, message: '请输入借款说明', trigger: 'blur' },
          ],
          file: [ // 上传附件
            { required: false, message: '请选择上传附件', trigger: 'blur' },
          ],
          // isNeedBill: [ // 借支票据
          //   { required: true, message: '请选择借支票据', trigger: 'blur' },
          // ],
          weight: [ // 过磅重量
            { required: true, message: '请输入过磅重量', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {

    handleTypeChange () {
      const loanSubject = this.$refs.baseForm.getVal('loanSubject');
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'hide',
        value: loanSubject !== '4',
        names: ['weight'],
      });
      this.$emit('getOtherFormVal', {
        from: 'insurance',
        tar: 'baseForm',
      });
      this.$emit('getOtherFormVal', {
        from: 'other',
        tar: 'baseForm',
      });
    },

    resetForm () {
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'hide',
        value: false,
        names: ['order', 'plateNumber', 'carOwnerName', 'carPhone'],
      });
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'hide',
        value: true,
        names: ['plateNumberInfo'],
      });
      this.baseForm.rules.file[0].required = true;
    },

    // 根据 LoanType 显示
    showFormByLoanType () {
      let names = [];
      if (this.$route.query.loanType === '1') {
        // 司机出车借支
        this.baseForm.rules.file[0].required = false;
      }
      if (this.$route.query.loanType === '2') {
        // 车辆维护借支
        names = ['order', 'plateNumber', 'carOwnerName', 'carPhone'];
        this.setFormAttrVal({
          form: this.baseForm,
          attr: 'hide',
          value: false,
          names: ['plateNumberInfo'],
        });
      }
      if (this.$route.query.loanType === '3') {
        // 员工借支
        names = ['order', 'plateNumber', 'carOwnerName', 'carPhone'];
      }
      if (names.length) {
        this.setFormAttrVal({
          form: this.baseForm,
          attr: 'hide',
          value: true,
          names,
        });
      }
    },

    handleOrderChange (data) {
      this.$refs.baseForm.setVal('carOwnerName', data.carDriverMan); // 司机姓名
      this.$refs.baseForm.setVal('carPhone', data.carDriverPhone); // 司机手机
      this.$refs.baseForm.setVal('plateNumber', data.plateNumber); // 车牌号
    },

    async setList (enumsList) {
      this.baseForm.loanSubjectOptions = enumsList[0];
      // this.baseForm.isNeedBillOptions = enumsList[1];
    },
    async handleSubData (cache) {
      let formData;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        if (formData.order) { // 订单
          formData.orderId = formData.order.orderId;
          delete formData.order;
        }
      }
      return formData;
    },
    async sub () {
      const formData = await this.handleSubData();
      if (formData) {
        formData.classify = 2;
        if (formData.file) { // 附件
          formData.fileId = formData.file.map((item) => item.id).join(',');
          delete formData.file;
        }
        formData.loanType = this.$route.query.loanType;
        if (this.$route.query.loanType === '2') {
          if (formData.plateNumberInfo && formData.plateNumberInfo.plateNumber) {
            formData.plateNumber = formData.plateNumberInfo.plateNumber;
          }
        }
        if (formData.loanSubject.length) {
          formData.loanSubject = formData.loanSubject.join(',');
        }
        delete formData.plateNumberInfo;
      }
      return formData;
    },
    async cacheData () {
      const formData = await this.handleSubData(true);
      if (formData.file && formData.file.length) { // 附件
        let fileUrl = [];
        let fileId = [];
        for (let item of formData.file) {
          fileId.push(item.id);
          fileUrl.push(item.url);
        }
        formData.fileUrl = fileUrl;
        formData.fileId = fileId;

        // formData.fileUrl = JSON.parse(JSON.stringify(formData.file));
        // formData.fileId = formData.file.map((item) => item.id).join(',');
        // formData.fileUrl = formData.file.map((item) => item.url).join(',');
        delete formData.file;
        formData.appDate = this.applyInfo.applyTime;
        formData.borrowName = this.applyInfo.borrowName;
      }
      return formData;
    },
    async init (data = {}) {
      this.applyInfo = {};
      if (data.appDate) {
        this.applyInfo.applyTime = data.appDate;
      }
      if (data.borrowName) {
        this.applyInfo.borrowName = data.borrowName;
      }
      if (data.plateNumber) {
        data.plateNumberInfo = {
          plateNumber: data.plateNumber,
        };
      }
      if (data.loanSubject) {
        if (!Array.isArray(data.loanSubject)) {
          data.loanSubject = data.loanSubject.split(',');
        }
      }
      // if (data.loanSubject) {
      //   data.loanSubject = String(data.loanSubject);
      // }
      // if (data.isNeedBill !== null && data.isNeedBill !== undefined) { // 借支票据
      //   data.isNeedBill = String(data.isNeedBill);
      // }
      if (data.amountDouble) {
        data.amount = data.amountDouble;
      }
      data.file = [];
      if (data.fileId && data.fileId.length) {
        const ids = data.fileId;
        const urls = data.fileUrl;
        urls.forEach((url, index) => {
          data.file.push({
            id: ids[index],
            url,
          });
        });
      }
      if (data.orderId) {
        data.order = {
          orderId: data.orderId,
          carDriverMan: data.carOwnerName,
          carDriverPhone: data.carPhone,
          plateNumber: data.plateNumber,
        };
      } else {
        data.order = {};
      }
      this.$refs.baseForm.setVal('form', data);
      this.resetForm();
      this.handleTypeChange();
      this.showFormByLoanType();
    },
  },
};
</script>

<style scoped lang="scss">
</style>
